var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"property-line"},[_c('h4',{staticClass:"header"},[_vm._v(_vm._s(_vm.header))]),_c('p',{staticClass:"line",attrs:{"contenteditable":"true"},domProps:{"textContent":_vm._s(_vm.inputText)},on:{"blur":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }